import { j as N } from "../../../node_modules/react/jsx-runtime.js";
import { memo as R } from "react";
import $ from "./Grid.module.scss.js";
import { clsx as b } from "../../../node_modules/clsx/dist/clsx.m.js";
const h = ({
  container: a,
  item: d,
  children: i,
  className: p,
  gridTemplateColumns: o,
  columnSpacing: r,
  gridAutoColumns: f,
  gridColumnEnd: x,
  gridColumnStart: u,
  spacing: s,
  gridArea: t,
  direction: m,
  gridAutoRows: y,
  justifyItems: G,
  alignItems: j,
  justifySelf: n,
  alignSelf: w,
  gridRow: c,
  gridRowEnd: g,
  gridRowStart: v,
  gridTemplate: A,
  gridTemplateAreas: C,
  gridTemplateRows: E,
  rowSpacing: e,
  ...l
}) => {
  const F = {
    gridTemplateColumns: o || "none",
    columnGap: r || 0,
    gridAutoColumns: f,
    gap: s || 0,
    gridArea: t && t,
    gridAutoFlow: m || "row",
    gridAutoRows: y,
    justifyItems: G,
    alignItems: j,
    justifySelf: n,
    alignSelf: w,
    gridColumnEnd: x,
    gridColumnStart: u,
    gridRow: c,
    gridRowEnd: g,
    gridRowStart: v,
    gridTemplate: A,
    gridTemplateAreas: C,
    gridTemplateRows: E,
    rowGap: e || 0
  };
  return /* @__PURE__ */ N.jsx(
    "div",
    {
      className: b((a || d) && $.gridClass, p),
      ...l,
      style: {
        ...F,
        ...l.style
      },
      children: i
    }
  );
}, D = R(h);
export {
  D as default
};
//# sourceMappingURL=Grid.js.map
